import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from 'src/app/modules/order/models/product';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shop-product',
  templateUrl: './shop-product.component.html',
  styleUrls: ['./shop-product.component.css']
})
export class ShopProductComponent implements OnInit {

  @Input()
  product: Product;

  @Input()
  hideProductName: boolean;

  @Output()
  productClick: EventEmitter<Product> = new EventEmitter<Product>();

  constructor() { }

  ngOnInit(): void {
  }

  onProductSelect(): void {
    this.productClick.emit(this.product);
  }

  get name(): string {
    return this.product?.name;
  }

  get description(): string {
    return this.product?.description;
  }

  get price(): number {
    return this.product?.price;
  }

  get imgUrl(): string {
    return this.product?.getProductImageUrl() || '/web/static/src/img/placeholder.png';
  }

  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }
}
